export default __webpack_public_path__ + "static/media/advisorymobile.c37244c0.png";